import { compose, replace, trim } from 'ramda';

export const trimNumber = compose(trim, replace(/\s/g, '')) || '';
